import { useLocation, useNavigate } from "react-router-dom";

function PricingNavLink({ className = "nav-link", children }) {
  const location = useLocation();
  const navigate = useNavigate();

  function handleClick(e) {
    e.preventDefault();
    if (location.pathname === "/" || location.pathname === "/landing-page") {
      const el = document.getElementById("pricing");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      } else {
        window.location.hash = "#pricing";
      }
    } else {
      navigate("/", { replace: false });
      setTimeout(() => {
        const el = document.getElementById("pricing");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 400);
    }
  }

  return (
    <a href="#pricing" className={className} onClick={handleClick}>
      {children}
    </a>
  );
}

export default PricingNavLink;
